import React from 'react';
import {Container,Row,Col} from "react-bootstrap"
// import BgImg from "../../images/home-update/sub-bg-image.png";
import {
    HomeUpdatedonedev,
    HomeUpdatedtwodev,
    HomeUpdatedthreedev,
    HomeUpdatedfourdev,
    HomeUpdatedfivedev,
    HomeUpdatedsixdev,
    HomeUpdatedsevendev,
    HomeUpdatedeightdev,
} from "../../../app-constants";

function Predevelop(props) {


    return (

        <section className="tekrevol__develop tekrevol_gray_bg p-100">
        <Container>
            <Row>

                <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="">
                    <div className="example example-bottom" data-text="Our Process">
                        <h2>Guided Roadmap to Digital Success</h2>
                    </div>
                </Col>

            </Row>
            <Row>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-4"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">01</span>
                            <div className="img">{HomeUpdatedonedev}</div>
                            <h3 className="title">Discovery & <br className='d-xl-block d-none' />Analysis</h3>
                            <p>Identify business needs and technical requirements through in-depth consultations. Analyze current systems and processes to pinpoint areas for improvement.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-4"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">02</span>
                            <div className="img">{HomeUpdatedtwodev}</div>
                            <h3 className="title">Feasibility & Impact Assessment</h3>
                            <p>Evaluate technical feasibility and potential impact on business operations. Provide detailed cost and timeline estimates based on comprehensive analysis.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-4"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">03</span>
                            <div className="img">{HomeUpdatedthreedev}</div>
                            <h3 className="title">Solution Architecture Design</h3>
                            <p>Develop a robust, scalable architecture tailored to your business needs. Ensure seamless integration with existing systems and future scalability.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-4"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">04</span>
                            <div className="img">{HomeUpdatedfourdev}</div>
                            <h3 className="title">Technology Selection & Prototyping</h3>
                            <p>Select the most suitable technologies and create prototypes. Validate design choices and gather stakeholder feedback for iterative improvements.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-xl-0 mb-4">
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">05</span>
                            <div className="img">{HomeUpdatedfivedev}</div>
                            <h3 className="title">Agile Development Process</h3>
                            <p>Implement solutions using Agile methodologies. Ensure continuous integration, testing, and delivery for high-quality, reliable outputs.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-xl-0 mb-4">
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">06</span>
                            <div className="img">{HomeUpdatedsixdev}</div>
                            <h3 className="title">System Integration & Testing</h3>
                            <p>Integrate new solutions with existing infrastructure. Conduct thorough testing to ensure functionality, performance, and security.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="mb-md-0 mb-4">
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">07</span>
                            <div className="img">{HomeUpdatedsevendev}</div>
                            <h3 className="title">Deployment & User Training</h3>
                            <p>Deploy the solution across the organization. Provide comprehensive training to ensure smooth adoption and maximize user efficiency.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={3}
                    xxl={3}
                    className="">
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <span className="count">08</span>
                            <div className="img">{HomeUpdatedeightdev}</div>
                            <h3 className="title">Continuous Support & Optimization</h3>
                            <p>Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation.</p>
                        </div>
                    </div>
                            
                </Col>

            </Row>
        </Container>
    </section>


    );

}

export default Predevelop;